(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawture-club"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pawture-club'))customElements.define('pawture-club',class extends HTMLElement{
connectedCallback(){if(this._ready)return;this._ready=true;this._events=new AbortController();const signal=this._events.signal;const videos=[...this.querySelectorAll('video')];videos.forEach(video=>video.addEventListener('play',()=>videos.forEach(other=>{if(other!==video)other.pause()}),{signal}));this._observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause()}),{threshold:.15});videos.forEach(video=>this._observer.observe(video));document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(video=>video.pause())},{signal})}
disconnectedCallback(){this._observer?.disconnect();this._events?.abort();this._ready=false}
});

  } catch(e) { console.error(e); }
})();
})();
